/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/hooks/useDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import EndorsingOfficesContent from './EndorsingOfficesContent';
import AttachModal from '../components/AttachModal';
import DetachModal from '../components/DetachModal';

const form = {
  q: '',
};

function EndorsingOfficesContainer({
  match,
  history,
  getEndorsingOfficesList,
  endorsingOfficesList,
  isLoading,
  endorsingOfficesListPager,
  deleteEndorsingOffices,
  getSingleEndorsingOffices,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Endorsing Offices',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Endorsing Offices',
      modalSize: 'modal-md',
    });
  };

  const handleDelete = (data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this endorsing office?',
      () => {
        deleteEndorsingOffices(data.id, () => {
          getEndorsingOfficesList({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/bpls/settings/endorsing-offices/${id}`);
            getSingleEndorsingOffices(id);
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getEndorsingOfficesList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.q,
    sort_by: 'asc',
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getEndorsingOfficesList({ q: formData.q, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  const handleAttachModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <AttachModal id={data.id} />,
      title: 'Attach',
      modalSize: 'modal-md',
    });
  };

  const handleDetachModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <DetachModal dataInfo={data} id={data.id} />,
      title: 'Detach',
      modalSize: 'modal-md',
    });
  };

  return (
    <Route
      path={`${match.path}/:endorsingOfficesId?`}
      render={({ match: { params } }) => (
        <GenericListPair
          moduleName="Endorsing Offices"
          getData={getEndorsingOfficesList}
          setParams={param}
          setKeyword={handleOnChange}
          keyword={_.get(formData, 'q') || ''}
          keywordPlaceholder="Search..."
          pathName={`${match.path}/:endorsingOfficesId?`}
          listName="endorsingOffices"
          label="Endorsing Offices"
          renderItem={(item) => (
            <div className="p-3">{_.get(item, 'attributes.name')}</div>
          )}
          isLoading={isLoading}
          selected={params.endorsingOfficesId}
          data={endorsingOfficesList}
          dataPager={endorsingOfficesListPager}
          handleSelectRow={(data) => {
            history.push(`${match.url}/${_.get(data, 'id')}`);
          }}
          renderContent={() => (
            <React.Fragment>
              <Switch>
                <Route
                  path={`${match.path}/:endorsingOfficesId?`}
                  render={() => (
                    <EndorsingOfficesContent
                      handleAddModal={handleAddModal}
                      handleEdit={handleEdit}
                      // handleRemove={handleRemove}
                      handleDelete={handleDelete}
                      handleAttachModal={handleAttachModal}
                      handleDetachModal={handleDetachModal}
                    />
                  )}
                />
              </Switch>
              <Route
                path={`${match.path}/:endorsingOfficesId?`}
                render={() =>
                  !params.endorsingOfficesId &&
                  endorsingOfficesList.length > 0 ? (
                    <Redirect
                      to={`${match.url}/${_.get(endorsingOfficesList, '0.id')}`}
                    />
                  ) : null
                }
              />
            </React.Fragment>
          )}
        />
      )}
    />
  );
}

EndorsingOfficesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  deleteEndorsingOffices: PropTypes.instanceOf(Function).isRequired,
  getSingleEndorsingOffices: PropTypes.instanceOf(Function).isRequired,
  getEndorsingOfficesList: PropTypes.instanceOf(Function).isRequired,
  endorsingOfficesList: PropTypes.instanceOf(Array).isRequired,
  endorsingOfficesListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  endorsingOfficesList: _.get(api, `${c.GET_ENDORSING_OFFICES}.list`) || [],
  endorsingOfficesListPager:
    _.get(api, `${c.GET_ENDORSING_OFFICES}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_ENDORSING_OFFICES) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(EndorsingOfficesContainer);
